import React, { useState, useEffect } from 'react';
import { getRandomMeals } from '../utils/api';
import RecipeCard from '../components/RecipeCard';
import RecipeModal from '../components/RecipeModal';
import { Sparkles, RotateCcw } from 'lucide-react';

function Home({ onFavoriteChange }) {
    const [randomRecipes, setRandomRecipes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRecipe, setSelectedRecipe] = useState(null);

    useEffect(() => {
        const fetchRandomRecipes = async () => {
            setLoading(true);
            try {
                const recipes = await getRandomMeals(6);
                setRandomRecipes(recipes);
            } catch (error) {
                console.error('Error fetching random recipes:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRandomRecipes();
    }, []);

    const handleViewDetails = (recipe) => {
        setSelectedRecipe(recipe);
    };

    const handleCloseModal = () => {
        setSelectedRecipe(null);
    };

    const handleDiscoverMore = async () => {
        setLoading(true);
        try {
            const recipes = await getRandomMeals(6);
            setRandomRecipes(recipes);
        } catch (error) {
            console.error('Error fetching new recipes:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDiscoverRandom = async () => {
        try {
            const recipes = await getRandomMeals(1);
            if (recipes && recipes.length > 0) {
                setSelectedRecipe(recipes[0]);
            }
        } catch (error) {
            console.error('Error fetching random recipe:', error);
        }
    };

    return (
        <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1 className="hero-title">
                        Welcome to <span className="brand">Cooksy</span>
                    </h1>
                    <p className="hero-subtitle">
                        Discover amazing recipes from around the world
                    </p>
                    <button
                        className="cta-button"
                        onClick={handleDiscoverRandom}
                    >
                        Discover Recipes
                    </button>
                </div>
            </section>

            {/* Today's Recipes Section */}
            <section className="todays-recipes">
                <div className="container">
                    <div className="section-header">
                        <h2>
                            Today's Featured Recipes
                            <Sparkles size={28} />
                        </h2>
                        <button
                            className="refresh-btn"
                            onClick={handleDiscoverMore}
                            disabled={loading}
                            aria-label="Get new recipes"
                        >
                            <RotateCcw size={20} />
                        </button>
                    </div>

                    {loading ? (
                        <div className="loading">
                            <div className="loading-spinner"></div>
                            <p>Loading delicious recipes...</p>
                        </div>
                    ) : randomRecipes.length > 0 ? (
                        <div className="recipes-grid">
                            {randomRecipes.map(recipe => (
                                <RecipeCard
                                    key={recipe.idMeal}
                                    recipe={recipe}
                                    onViewDetails={handleViewDetails}
                                    onFavoriteChange={onFavoriteChange}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="no-recipes">
                            <p>No recipes found. Please try again!</p>
                            <button
                                className="retry-btn"
                                onClick={handleDiscoverMore}
                            >
                                Retry
                            </button>
                        </div>
                    )}
                </div>
            </section>

            {selectedRecipe && (
                <RecipeModal
                    recipe={selectedRecipe}
                    onClose={handleCloseModal}
                    onFavoriteChange={onFavoriteChange}
                />
            )}
        </div>
    );
}

export default Home;